<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="ArrowUpCircleIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="resendRecord" />
      <!--feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" /-->
    </div>
</template>

<script>
import firebase from '@/services/saleData'
import 'firebase/firestore'
export default {
  name: 'CellRendererActions',
  methods: {
    async resendRecord (){
      await firebase.firestore().collection('waste').doc(this.params.data.key).get().then((data)=>{
        if(!data.exists){
          this.$store.dispatch('report/setStatus', this.params.data.key);
        }
      })
    //  this.$store.commit('userManagement/SET_SELECTED', this.params.data);
    //  this.$store.commit('userManagement/SET_POPUP', true);
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    }
  }
}
</script>
